"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserForm = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const events_1 = require("@front/components/form-parts/events");
const component_1 = require("@front/components/form-parts/form/component");
const component_2 = require("@front/components/site-menu/component");
const component_3 = require("@front/layouts/default-layout/component");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const trans_1 = require("../../../../../common/translations/trans");
//@ts-ignore                
let rwsTemplate = T.html `<template>
    <div class="container-fluid">
        <div class="user-form-page">
            <div class="row">
                <div class="col-lg-6 col-12 pb-lg-5">
                    <div class="mb-2">
                        <h1>${x => x.userId ? 'user.form.title.edit'.t() : 'user.form.title.add'.t()}</h1>
                        <div class="text-zero top-right-button-container">
                            <button @click="${(x, c) => x.cancel(c.event)}" type="button"
                                class="top-right-button mr-1 btn btn-primary btn-lg">${'user.form.back'.t()}</button>
                        </div>
                    </div>
                    <div class="card card-body mb-5">
                        <the-form :onSubmit="${(x, c) => x.sendForm.bind(x)}">
                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <part-input 
                                        required="true"
                                        class="form-part" 
                                        label="${'user.form.username.label'.t()}" 
                                        :value="${x => x.form.username}"
                                        name="username" 
                                        placeholder="${'user.form.username.placeholder'.t()}"
                                    ></part-input>
                                </div>                         
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <part-input 
                                        required="true"
                                        class="form-part" 
                                        label="${'user.form.name.label'.t()}" 
                                        :value="${x => x.form.name}"
                                        name="name" 
                                        placeholder="${'user.form.name.placeholder'.t()}"
                                    ></part-input>
                                </div>
                                <div class="form-group col-md-6">
                                    <part-input 
                                        class="form-part" 
                                        label="${'user.form.last_name.label'.t()}" 
                                        :value="${x => x.form.last_name}"
                                        name="last_name" 
                                        placeholder="${'user.form.last_name.placeholder'.t()}"
                                    ></part-input>
                                </div>
                            </div>                            
                            <div class="form-group">
                                <part-input 
                                    required="true"
                                    class="form-part" 
                                    label="${'user.form.email.label'.t()}" 
                                    :value="${x => x.form.email}"
                                    name="email" 
                                    type="email" 
                                    placeholder="${'user.form.email.placeholder'.t()}"
                                ></part-input>
                            </div>
                            <div class="form-group">
                                <part-select 
                                    required="true"
                                    class="form-part" 
                                    label="${'user.form.language.label'.t()}" 
                                    :value="${x => x.form.language}"
                                    name="language"
                                    placeholder="${'user.form.language.placeholder'.t()}"
                                    :options="${x => x.languageOptions}"
                                ></part-select>
                            </div>
                            <div class="form-group">
                                <part-input 
                                    class="form-part"
                                    label="${x => x.userId ? 'user.form.password.new.label'.t() : 'user.form.password.label'.t()}"
                                    :value="${x => x.form.passwd}" 
                                    name="passwd" 
                                    type="password" 
                                    placeholder="${'user.form.password.placeholder'.t()}"
                                    required="${x => !x.userId ? 'true' : 'false'}"
                                ></part-input>
                            </div>
                            <div class="form-group">
                                <part-input 
                                    class="form-part"
                                    label="${x => x.userId ? 'user.form.password.repeat.new.label'.t() : 'user.form.password.repeat.label'.t()}"
                                    :value="${x => x.form.repeat_passwd}" 
                                    name="repeat_passwd" 
                                    type="password"
                                    placeholder="${'user.form.password.repeat.placeholder'.t()}"
                                    required="${x => !x.userId ? 'true' : 'false'}"
                                ></part-input>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <part-select 
                                        required="true"
                                        class="form-part" 
                                        label="${'user.form.role.label'.t()}" 
                                        :value="${x => x.form.role}" 
                                        name="role"
                                        placeholder="${'user.form.role.placeholder'.t()}"
                                        :options="${x => x.userRoles.map(role => ({ label: x.roleText(role), value: role }))}"
                                    ></part-select>
                                </div>
                                <div class="form-group col-md-6">
                                    <div class="form-check mt-4">
                                        <part-checkbox 
                                            class="form-part" 
                                            label="${'user.form.active.label'.t()}" 
                                            :value="${x => x.form.active}"
                                            name="active"
                                        ></part-checkbox>
                                    </div>
                                </div>
                            </div>

                            ${(0, fast_element_1.when)(x => x.isSuperAdmin, (0, fast_element_1.html) `
                                <div class="form-group">                                                                
                                    <label class="form-label">${'user.form.company.label'.t()}</label>
                                    <v-select 
                                        class="form-part"
                                        :value="${x => x.form.companyId}" 
                                        name="companyId"
                                        :choiceList="${x => x.userCompanies.map(company => ({ label: company.name, value: company.id }))}"
                                        placeholder="${'user.form.company.placeholder'.t()}"
                                        @change="${(x, c) => x.handleCompanyChange(c.event)}"
                                    ></v-select>                                  
                                </div>
                            `)}

                            <div class="form-group">                            
                                <div class="user-group-field-wrapper">                                        
                                    <part-select class="form-part" label="${'user.form.userGroup.label'.t()}" :value="${x => x.form.userGroupId}" name="userGroupId"
                                        :options="${x => [{ label: 'common.none'.t(), value: '' }, ...x.userGroups.map(group => ({ label: group.name, value: group.id }))]}"
                                    ></part-select>
                                    <button type="button" class="btn btn-outline-primary btn-sm add-user-group-btn"
                                        @click="${(x, c) => x.openUserGroupModal()}" title="${'user.form.userGroup.add'.t()}">
                                        <i class="simple-icon-plus"></i> ${'route.userGroup.create'.t()}
                                    </button>
                                </div>
                            </div>

                            <div class="form-group mt-4">
                                <button @click="${(x, c) => x.sendSubmit(x, c)}" type="submit" class="btn btn-primary btn-lg mr-2"
                                    ?disabled="${x => x.loading}">
                                    ${x => x.userId ? 'user.form.submit.update'.t() : 'user.form.submit.create'.t()}
                                </button>
                            </div>
                        </the-form>
                    </div>
                </div>
                
                
                <div class="col-lg-6 col-12 pb-lg-5">
                    <div class="mb-2">
                        <h2>${'user.form.preview.title'.t()}</h2>
                    </div>
                    <div class="card card-body">
                        ${(0, fast_element_1.when)(x => x.form.userGroupId && x.selectedUserGroupACL, (0, fast_element_1.html) `
                            <div class="access-preview">
                                <h5 class="mb-3">${'user.form.preview.selectedGroup'.t()}: 
                                    <span class="text-primary">${x => {
    const group = x.userGroups.find(g => { var _a, _b; return ((_a = g.id) === null || _a === void 0 ? void 0 : _a.toString()) === ((_b = x.form.userGroupId) === null || _b === void 0 ? void 0 : _b.toString()); });
    return group ? group.name : '';
}}</span>
                                </h5>
                                <div class="access-details">
                                    <h6>${'user.form.preview.permissions'.t()}:</h6>
                                    <div class="acl-permissions">
                                        ${(0, fast_element_1.repeat)(x => Object.keys(x.getDisplayACL(x.selectedUserGroupACL) || {}), (0, fast_element_1.html) `
                                            <div class="permission-group mb-2">
                                                <p class="mb-1">
                                                    <strong>${resourceKey => `acl_resource.${resourceKey}`.t()}:</strong>
                                                    ${(0, fast_element_1.repeat)((resourceKey, c) => c.parent.getDisplayACL(c.parent.selectedUserGroupACL)[resourceKey] || [], (0, fast_element_1.html) `
                                                        <span class="badge mr-1 ${actionKey => actionKey === 'read' ? 'badge-success' :
    actionKey === 'write' ? 'badge-primary' : 'badge-danger'}">${actionKey => `acl_action.${actionKey}`.t()}</span>
                                                    `)}
                                                </p>
                                            </div>
                                        `)}
                                        ${(0, fast_element_1.when)(x => !x.getDisplayACL(x.selectedUserGroupACL) || Object.keys(x.getDisplayACL(x.selectedUserGroupACL)).length === 0, (0, fast_element_1.html) `
                                            <p class="text-muted">${'user.form.preview.noAccess'.t()}</p>
                                        `)}
                                    </div>
                                </div>
                            </div>
                        `)}
                        ${(0, fast_element_1.when)(x => !x.form.userGroupId, (0, fast_element_1.html) `
                            <div class="text-muted text-center py-4">
                                <i class="simple-icon-info display-4 mb-3"></i>
                                <p>${'user.form.preview.selectGroup'.t()}</p>
                            </div>
                        `)}
                        ${(0, fast_element_1.when)(x => x.form.userGroupId && !x.selectedUserGroupACL, (0, fast_element_1.html) `
                            <div class="text-muted text-center py-4">
                                <i class="simple-icon-lock display-4 mb-3"></i>
                                <p>${'user.form.preview.noAccess'.t()}</p>
                            </div>
                        `)}
                    </div>
                </div>
            </div>
        </div>
    </div>

    
    ${(0, fast_element_1.when)(x => x.showUserGroupModal, (0, fast_element_1.html) `
        <rws-modal header="userGroup.form.title.add" centerTop="false" :closeModal="${x => x.closeUserGroupModal.bind(x)}">
            <user-group-form-content       
                :companyId="${x => x.form.companyId}"           
                :isModalMode="${() => true}"
                @user-group-saved="${(x, c) => x.handleUserGroupCreated.bind(x)(c.event)}"
                @cancel="${(x, c) => x.closeUserGroupModal()}">
            </user-group-form-content>
        </rws-modal>
    `)}
</template>`;
require("./styles/layout.scss");
const styles = T.css `.user-form-page .top-right-button-container {
  float: right;
}
.user-form-page .form-check {
  margin-bottom: 0.5rem;
}
.user-form-page .form-check:last-child {
  margin-bottom: 0;
}
.user-form-page .form-label {
  font-weight: 600;
  margin-bottom: 0.5rem;
}
.user-form-page .user-group-field-wrapper {
  display: flex;
  gap: 10px;
}
.user-form-page .user-group-field-wrapper .form-part {
  flex: 1;
}
.user-form-page .user-group-field-wrapper .add-user-group-btn {
  margin-bottom: 0;
  height: fit-content;
  padding: 0.375rem 0.75rem;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.875rem;
}
.user-form-page .user-group-form-modal-content {
  max-width: 800px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
}
.user-form-page .user-group-form-modal-content .modal-header {
  border-bottom: 1px solid var(--separator-color);
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.user-form-page .user-group-form-modal-content .modal-header .modal-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
}
.user-form-page .user-group-form-modal-content .modal-header .btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
  color: var(--text-muted);
}
.user-form-page .user-group-form-modal-content .modal-header .btn-close:hover {
  color: var(--text-color);
}
.user-form-page .user-group-form-modal-content .modal-body {
  padding: 1.5rem;
}
.user-form-page .access-preview .access-details h6 {
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: var(--text-color);
}
.user-form-page .access-preview .access-details .badge {
  font-size: 0.75rem;
  margin-right: 0.25rem;
  margin-bottom: 0.25rem;
}
.user-form-page .access-preview .access-details p {
  margin-bottom: 0.5rem;
}
.user-form-page .access-preview .access-details p strong {
  font-weight: 600;
  color: var(--text-color);
}
.user-form-page .text-primary {
  color: var(--primary-color) !important;
}
.user-form-page .text-muted {
  color: var(--text-muted) !important;
}
.user-form-page .display-4 {
  font-size: 2.5rem;
}`;
const shadowOptions = { "mode": "open" };
let UserForm = class UserForm extends client_1.RWSViewComponent {
    constructor(popupService) {
        super();
        this.popupService = popupService;
        this.loading = false;
        this.userId = null;
        this.userRoles = [];
        this.userCompanies = [];
        this.userGroups = [];
        this.showUserGroupModal = false;
        this.selectedUserGroupACL = null;
        this.formListenerActive = true;
        this.languageOptions = [
            { label: 'lang.en', value: 'en' },
            { label: 'lang.de', value: 'de' },
            { label: 'lang.es', value: 'es' },
            { label: 'lang.it', value: 'it' },
            { label: 'lang.pl', value: 'pl' },
            { label: 'lang.zh', value: 'zh' }
        ];
        this.form = {
            name: '',
            last_name: '',
            username: '',
            passwd: '',
            repeat_passwd: '',
            email: '',
            companyId: '',
            active: true,
            role: backendImport_1.UserRoles.USER,
            parentId: '',
            userGroupId: '',
            language: (0, trans_1.getCurrentLanguage)()
        };
        this.sendSubmit = component_1.FormComponent.sendSubmitEvent;
    }
    async connectedCallback() {
        super.connectedCallback();
        this.userId = this.routeParams.id;
        // Extract user ID from URL if in edit mode
        if (this.userId) {
            await this.loadUser();
        }
        if (component_3.DefaultLayout.USER.role === backendImport_1.UserRoles.SUPER_ADMIN) {
            this.userRoles = Object.values(backendImport_1.UserRoles);
            this.userCompanies = (await this.apiService.back.get('company.list', { queryParams: { all: '1' } })).data;
        }
        else {
            this.userRoles = [backendImport_1.UserRoles.USER];
            // For non-super admins, company will be inherited from parent user via controller
            this.userCompanies = [];
        }
        this.loadUserGroups();
        // Set up form change listening with a flag to control when it's active
        this.on(events_1.inputEvents.changed, (event) => {
            if (this.formListenerActive) {
                component_1.FormComponent.assignFormValues.bind(this)('form', event);
                // Update ACL preview when userGroupId changes
                if (event.detail.fieldName === 'userGroupId') {
                    this.updateSelectedUserGroupACL();
                }
            }
        });
    }
    resetForm() {
        this.form = {
            name: '',
            last_name: '',
            username: '',
            passwd: '',
            repeat_passwd: '',
            email: '',
            companyId: '',
            active: true,
            role: backendImport_1.UserRoles.USER,
            parentId: '',
            userGroupId: ''
        };
    }
    async loadUserGroups() {
        // Load user groups
        try {
            const queryParams = this.isSuperAdmin && this.form.companyId ? { all: '1', company_id: this.form.companyId } : { all: '1' };
            const userGroupsResponse = await this.apiService.back.get('user-group.list', { queryParams });
            if (userGroupsResponse.success) {
                this.userGroups = userGroupsResponse.data || [];
                if (component_3.DefaultLayout.USER.role === backendImport_1.UserRoles.SUPER_ADMIN) {
                    this.userGroups = this.userGroups.map(ug => {
                        return {
                            ...ug,
                            name: `${ug.name} (${ug.company ? ug.company.name : ug.owner_name})`
                        };
                    });
                }
                this.updateSelectedUserGroupACL();
            }
        }
        catch (error) {
            console.error('Failed to load user groups:', error);
        }
    }
    updateSelectedUserGroupACL() {
        console.log('updateSelectedUserGroupACL called', {
            userGroupId: this.form.userGroupId,
            userGroups: this.userGroups.length
        });
        if (this.form.userGroupId) {
            const selectedGroup = this.userGroups.find(group => { var _a, _b; return ((_a = group.id) === null || _a === void 0 ? void 0 : _a.toString()) === ((_b = this.form.userGroupId) === null || _b === void 0 ? void 0 : _b.toString()); });
            console.log('selectedGroup:', selectedGroup);
            this.selectedUserGroupACL = (selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.acl) || null;
            console.log('selectedUserGroupACL:', this.selectedUserGroupACL);
        }
        else {
            this.selectedUserGroupACL = null;
        }
    }
    getDisplayACL(rawACL) {
        if (!rawACL || typeof rawACL !== 'object')
            return null;
        const displayACL = {};
        for (const [enumResource, enumActions] of Object.entries(rawACL)) {
            const resourceKey = backendImport_1.ACL.getResourceDisplayKey(enumResource);
            displayACL[resourceKey] = enumActions.map((enumAction) => backendImport_1.ACL.getActionDisplayKey(enumAction));
        }
        return displayACL;
    }
    get isSuperAdmin() {
        return component_3.DefaultLayout.USER.role === backendImport_1.UserRoles.SUPER_ADMIN;
    }
    handleCompanyChange(event) {
        const target = event.target;
        if (target && target.value) {
            this.form = { ...this.form, companyId: target.value, userGroupId: '' };
            this.loadUserGroups();
        }
    }
    openUserGroupModal() {
        this.showUserGroupModal = true;
        // Pause form change listening while modal is open
        this.formListenerActive = false;
    }
    closeUserGroupModal() {
        this.showUserGroupModal = false;
        // Re-enable form change listening when modal closes
        this.formListenerActive = true;
    }
    async handleUserGroupCreated(event) {
        const { userGroup } = event.detail;
        // Close modal first
        this.closeUserGroupModal();
        // Refresh the user group list and then set the new value
        await this.loadUserGroups();
        // Auto-select the newly created user group
        this.form = { ...this.form, userGroupId: userGroup.id };
        this.updateSelectedUserGroupACL();
        console.log('cr', { event }, this.form.userGroupId);
    }
    formChanged(oldValue, newValue) {
        console.log({ oldValue, newValue });
    }
    async loadUser() {
        var _a, _b;
        if (!this.userId)
            return;
        this.loading = true;
        try {
            const response = await this.apiService.back.get('user.get', {
                routeParams: { id: this.userId }
            });
            if (response.success && response.data) {
                const user = response.data;
                let companyId = '';
                if (this.userId) {
                    // For existing users, get their current company
                    companyId = ((_a = user.company) === null || _a === void 0 ? void 0 : _a.id) || '';
                }
                this.form = {
                    name: user.name,
                    last_name: user.last_name || '',
                    username: user.username,
                    email: user.email,
                    passwd: '', // Don't load password for security
                    active: user.active,
                    companyId: companyId,
                    role: user.role,
                    parentId: user.parentId || '',
                    userGroupId: ((_b = user.userGroup) === null || _b === void 0 ? void 0 : _b.id) || '',
                    language: user.language || (0, trans_1.getCurrentLanguage)()
                };
                this.loadUserGroups();
            }
            else {
                this.notifyService.notify(response.error || 'user.form.load.error'.t(), 'error');
            }
        }
        catch (e) {
            this.notifyService.notify('user.form.load.error'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    async sendForm(event) {
        event.preventDefault();
        // Validate that user group is selected for new users
        if (!this.userId && !this.form.userGroupId) {
            this.popupService.error('user.form.error.userGroup_required'.t());
            return;
        }
        try {
            this.loading = true;
            let response;
            // Create a copy of form data for sending
            const formData = { ...this.form };
            // Convert empty userGroupId to null to explicitly clear user group
            if (!formData.userGroupId) {
                formData.userGroupId = null;
            }
            if (this.userId && (!formData.passwd || formData.passwd.trim() === '')) {
                delete formData.passwd;
                delete formData.repeat_passwd;
            }
            if (this.userId) {
                response = await this.apiService.back.put('user.update', formData, {
                    routeParams: { id: this.userId }
                });
            }
            else {
                response = await this.apiService.back.post('user.create', formData);
            }
            if (!response.success) {
                console.error(response.error);
                this.notifyService.notify(response.error || `Failed to ${this.userId ? 'update' : 'create'} user`, 'error');
            }
            else {
                const successMessage = this.userId ? 'user.form.submit.updateSuccess'.t() : 'user.form.submit.createSuccess'.t();
                this.notifyService.notify(successMessage, 'info');
                this.$emit('user-saved', { user: response.data });
                this.resetForm();
                component_2.SiteMenu.goto.bind(this)('/user/list');
            }
        }
        catch (e) {
            console.error(e);
            this.notifyService.notify(`Failed to ${this.userId ? 'update' : 'create'} user`, 'error');
        }
        finally {
            this.loading = false;
        }
    }
    roleText(userRole) {
        return (0, backendImport_1.getRoleText)(userRole);
    }
    cancel(event) {
        event.preventDefault();
        component_2.SiteMenu.goto.bind(this)('/user/list');
    }
};
exports.UserForm = UserForm;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], UserForm.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], UserForm.prototype, "userId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], UserForm.prototype, "userRoles", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], UserForm.prototype, "userCompanies", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], UserForm.prototype, "userGroups", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], UserForm.prototype, "showUserGroupModal", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof backendImport_1.IACLPolicyEntry !== "undefined" && backendImport_1.IACLPolicyEntry) === "function" ? _b : Object)
], UserForm.prototype, "selectedUserGroupACL", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], UserForm.prototype, "languageOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_c = typeof backendImport_1.IUserPayload !== "undefined" && backendImport_1.IUserPayload) === "function" ? _c : Object)
], UserForm.prototype, "form", void 0);
exports.UserForm = UserForm = __decorate([
    (0, client_1.RWSView)('user-form', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object])
], UserForm);
UserForm.defineComponent();
